import { render, staticRenderFns } from "./payg-checkout.vue?vue&type=template&id=11997eb0&"
import script from "./payg-checkout.vue?vue&type=script&lang=js&"
export * from "./payg-checkout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports